const cookieToken = require("./cookie-token");

const logoutChannel = new BroadcastChannel("account-token-channel");

const AccountTokenStoragePort = {
  getItem: function (_key) {
    void _key;
    return cookieToken.get();
  },

  add: (app) => {
    app.ports.setTokenPort.subscribe((object) => {
      cookieToken.set(object.value);
    });

    app.ports.removeTokenPort.subscribe(() => {
      cookieToken.remove();
      logoutChannel.postMessage("logout");
      app.ports.accountTokenRemovedPort.send(null);
    });

    logoutChannel.onmessage = (event) => {
      if (event.data === "logout") {
        app.ports.accountTokenRemovedPort.send(null);
      }
    };
  },
};

module.exports = AccountTokenStoragePort;
